import React from "react";
import styles from "./Input.module.css";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    label: string;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
    ({ label, id, className = "", ...props }, ref) => {
        const textareaId = id || label.replace(/\s+/g, "-").toLowerCase();

        return (
            <div className={`${styles.inputWrapper} ${className}`}>
                <textarea
                    ref={ref}
                    id={textareaId}
                    className={styles.textarea}
                    placeholder=" "
                    {...props}
                />
                <label htmlFor={textareaId} className={styles.label}>
                    {label}
                </label>
            </div>
        );
    }
);

Textarea.displayName = "Textarea";
